import creditsReducer from 'src/redux/slices/creditSlice';
import userReducer from 'src/redux/slices/userSlice';
import { appsApi } from 'src/redux/services/apps';
import { usersAdminApi } from 'src/redux/services/usersAdmin';
import { usersApi } from 'src/redux/services/users';
import { authApi } from 'src/redux/services/auth';
import { receiptApi } from 'src/redux/services/receipt';
import { scoreApi } from 'src/redux/services/score';
import { notificationApi } from 'src/redux/services/notifications';
import { companiesAdminApi } from 'src/redux/services/companiesAdmin';
import { customersApi } from 'src/redux/services/customers';
import { loginSimulatorApi } from 'src/redux/services/login';

const rootReducer = {
  creditReducer: creditsReducer,
  user: userReducer,
  [appsApi.reducerPath]: appsApi.reducer,
  [usersAdminApi.reducerPath]: usersAdminApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [companiesAdminApi.reducerPath]: companiesAdminApi.reducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [receiptApi.reducerPath]: receiptApi.reducer,
  [scoreApi.reducerPath]: scoreApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [loginSimulatorApi.reducerPath]: loginSimulatorApi.reducer,
};

export default rootReducer;
